var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useLang } from '../hooks/use-lang';
var cls = classNames('data-grid-cell-empty');
export var DataGridCellEmptyDefaultProps = {
  text: '(none)'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('subtle'))
});
// -------- Components -------->
var My = {
  NAME: 'DataGridCellEmpty',
  Container: styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var DataGridCellEmpty = function (props) {
  var componentProps = useComponentProps(My.NAME, DataGridCellEmptyDefaultProps, props);
  var className = componentProps.className,
    text = componentProps.text;
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, t(text));
};
DataGridCellEmpty.cls = cls;
var templateObject_1, templateObject_2;